<template>
  <div class="list-box" style="padding: 0; padding-top: 10px">
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          sortable="create_time"
          prop="create_time"
          label="操作时间"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="type_name"
          label="操作类型"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column prop="msg" label="操作说明" min-width="180" />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showInfo"
      :title="(state.selectId ? '修改' : '添加') + '角色'"
      @close="state.showInfo = false"
    >
      <c_RoleInfo
        @close="
          state.showInfo = false;
          onLoad();
        "
        :id="state.selectId"
      ></c_RoleInfo>
    </c_popup>
  </transition>
  <transition name="el-zoom-in-center">
    <c_popup v-if="state.showYh" title="绑定用户" @close="state.showYh = false">
      <c_RoleBindYh
        @close="
          state.showYh = false;
          onLoad();
        "
        :id="state.selectId"
      ></c_RoleBindYh>
    </c_popup>
  </transition>
  <el-drawer
    v-model="state.showQx"
    :key="state.key"
    :with-header="false"
    size="50%"
  >
    <c_RoleSetQx
      :id="state.selectId"
      @close="state.showQx = false"
    ></c_RoleSetQx>
  </el-drawer>
</template>

<script>
import { onMounted, reactive } from "vue";
import { salaryapply_log } from "@/http/salaryapply";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
  };
}
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.salary_apply_id = props.id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      salaryapply_log(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    return {
      state,
      onLoad,
      onSortChange,
    };
  },
};
</script>
<style scoped></style>
